const updateRoles = {
  toastr: 'Función actualizada',
  toastr1: ' fue actualizado con éxito',
  toastrError: 'Función ya registrada',
  toastrError1: 'Ingrese otro nombre'
};

export default updateRoles;
